<template>
  <div class="finance-zone">
    <!-- 头部导航 -->
    <div
      class="header"
      :style="statusBarHeight > 0 ? { paddingTop: `${statusBarHeight + 6}px` } : {}"
    >
      <div class="back" @click="onClickLeft">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <div class="title">{{ detailInfo.title || '金融专区' }}</div>
      <div class="placeholder"></div>
    </div>

    <div
      v-if="loading"
      class="loading-box"
      :style="statusBarHeight > 0 ? { paddingTop: `${statusBarHeight + 52}px` } : {}"
    >
      <span class="loading-spinner"></span>
      <span class="loading-text">加载中...</span>
    </div>

    <div
      v-else-if="hasData"
      class="content-body"
      :style="statusBarHeight > 0 ? { paddingTop: `${statusBarHeight + 52}px` } : {}"
      @click="handleRichTextLinkClick"
    >
      <!-- 顶部 Banner 区域 -->
      <div v-if="detailInfo.imageUrl" class="banner-box">
        <img :src="detailInfo.imageUrl" class="banner-img" alt="金融专区 Banner" />
      </div>

      <!-- 企业介绍 -->
      <div class="section-box">
        <div class="section-title">
          <span class="red-line"></span>
          <span>企业介绍</span>
        </div>
        <div class="rich-text-container" v-html="detailInfo.companyIntro"></div>
      </div>

      <!-- 金融产品 -->
      <div v-if="detailInfo.productList && detailInfo.productList.length > 0" class="section-box">
        <div class="section-title">
          <span class="red-line"></span>
          <span>金融产品</span>
        </div>
        <div
          v-for="(item, index) in detailInfo.productList"
          :key="index"
          class="product-card"
        >
          <!-- 右上角钱袋图标图片 -->
          <img :src="cardIcon" class="card-money-bag" alt="卡片图标" />

          <!-- 产品标题 -->
          <div class="product-card-title">
            <span class="red-square"></span>
            <span class="title-text">{{ item.productName || item.name }}</span>
          </div>

          <!-- 产品富文本内容 -->
          <div class="rich-text-container product-desc" v-html="item.productIntro || item.desc"></div>
        </div>
      </div>

      <!-- 其他说明 -->
      <div v-if="hasContent(detailInfo.otherIntro)" class="section-box">
        <div class="section-title">
          <span class="red-line"></span>
          <span>其他说明</span>
        </div>
        <div class="rich-text-container" v-html="detailInfo.otherIntro"></div>
      </div>
    </div>

    <!-- 暂无数据缺省图提示 -->
    <div v-else class="empty-box">
      <img :src="noResultImg" class="empty-img" alt="暂无数据" />
      <div class="empty-text">暂无数据</div>
    </div>

    <!-- 底部固定按钮入口 -->
    <div class="bottom-action-bar">
      <!-- 恢复原生定位时放回属性：:loading="requestingArea" 与 loading-text="正在获取定位信息..." -->
      <van-button
        type="danger"
        block
        round
        class="calc-btn"
        @click="handleJumpToCalculator"
      >
        我要贷款计算
      </van-button>
    </div>
  </div>
</template>

<script>
import { getFinanceTopicDetail } from '@/api'
import cardIcon from '@/assets/images/finance-zone/card_icon.png'
import noResultImg from '@/assets/images/noResult1.png'

// 金融计算器默认省市编码：安徽省 / 合肥市
const DEFAULT_PROVINCE_ID = '340000'
const DEFAULT_CITY_ID = '340100'

export default {
  name: 'FinanceZone',
  data() {
    return {
      statusBarHeight: this.isRedmiDevice() ? 32 : 0,
      cardIcon,
      noResultImg,
      topicId: '',
      detailInfo: {},
      loading: true
      // 原生定位桥接状态（暂时注释，恢复时记得给上方 loading 补回逗号）
      // requestingArea: false,
      // nativeAreaResolve: null,
      // nativeAreaReject: null,
      // nativeAreaTimer: null,
      // nativeAreaCallback: null,
      // nativeAreaPermissionGranted: false
    }
  },
  computed: {
    hasData() {
      const {
        imageUrl,
        companyIntro,
        productList,
        otherIntro
      } = this.detailInfo || {}
      return Boolean(
        imageUrl
        || this.hasContent(companyIntro)
        || (productList && productList.length > 0)
        || this.hasContent(otherIntro)
      )
    }
  },
  created() {
    this.statusBarHeight = this.isRedmiDevice() ? 32 : 0
    console.log('红米机型测试', navigator.userAgent.toLowerCase(), this.statusBarHeight, this.isRedmiDevice())

    this.topicId = this.$route.query.topicId || this.$route.query.id || ''
    if (this.topicId) {
      this.fetchDetail(this.topicId)
    } else {
      this.loading = false
    }

    // 原生省市回调注册（暂时注释，恢复原生定位时放开）
    // this.nativeAreaCallback = (payload) => {
    //   this.handleProvinceAndCityCallback(payload)
    // }
    // window.getProvinceAndCity = this.nativeAreaCallback
  },
  mounted() {
    // 监听从其它 H5 页面返回（pageshow 会在 BFCache 页面恢复时 100% 触发）
    window.addEventListener('pageshow', this.handlePageShow)
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.handlePageShow)
    // 原生省市回调解绑（暂时注释，恢复原生定位时放开）
    // if (window.getProvinceAndCity === this.nativeAreaCallback) {
    //   window.getProvinceAndCity = undefined
    // }
    // this.clearNativeAreaRequest()
  },
  methods: {
    // 页面唤醒/回退事件恢复状态栏高度
    handlePageShow(e) {
      this.statusBarHeight = this.isRedmiDevice() ? 32 : 0
      this.$forceUpdate()
    },
    // 仅针对红米（Redmi）机型识别，其他手机保持 0
    // 识别是否为红米设备 (包含各种内嵌WebView特征、Redmi代号及主流K系列/Note系列特征)
    isRedmiDevice() {
      const ua = navigator.userAgent.toLowerCase()

      // 1. 包含明文关键词 (redmi, poco, hongmi, hm)
      if (/(redmi|poco|hongmi|\bhm[-_\s]|\bhm\d)/i.test(ua)) {
        return true
      }

      // 2. 包含常见红米具体系列型号 (如 Redmi K系列, Note系列)
      if (/\b(k[2-8]0|redmi\s*note)\b/i.test(ua)) {
        return true
      }

      // 3. 针对红米/小米硬件代号规则：
      // 包含 M开头代号（如 m2004j7ac 即 Redmi 10X）以及 2开头代号（如 23049rad8c, 2311drk48c 等）
      if (/\b(m\d{4}[0-9a-z]{3,6}|2\d{3}[0-9a-z]{5,7})\b/i.test(ua)) {
        return true
      }

      return false
    },
    /**
     * 判断字符串/富文本内容是否真正非空（自动剔除空 HTML 标签及空白字符）
     */
    hasContent(str) {
      if (!str) return false
      if (typeof str !== 'string') return Boolean(str)
      if (/<(img|video|iframe|embed|audio)\b/i.test(str)) {
        return true
      }
      const pureText = str
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/ig, '')
        .replace(/\s+/g, '')
      return pureText.length > 0
    },
    /**
     * 获取金融购车专题详情
     * 接口地址: /zhixiao/api/financeTopic/detail?topicId=...
     */
    fetchDetail(topicId) {
      this.loading = true
      getFinanceTopicDetail({ topicId })
        .then((res) => {
          if (res && res.data) {
            this.detailInfo = res.data
            if (res.data.title) {
              document.title = res.data.title
            }
          }
        })
        .catch((err) => {
          console.warn('获取金融专题详情接口失败:', err.message)
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 调用原生关闭页面桥接方法 (closePage)
     */
    invokeNativeClosePage() {
      if (
        window.HarmonyOS
        && typeof window.HarmonyOS.closePage === 'function'
      ) {
        window.HarmonyOS.closePage()
        return true
      }
      if (window.ohos && typeof window.ohos.closePage === 'function') {
        window.ohos.closePage()
        return true
      }
      if (window.Android && typeof window.Android.closePage === 'function') {
        window.Android.closePage()
        return true
      }
      if (
        window.webkit
        && window.webkit.messageHandlers
        && window.webkit.messageHandlers.closePage
      ) {
        window.webkit.messageHandlers.closePage.postMessage(null)
        return true
      }
      if (window.uni && typeof window.uni.navigateBack === 'function') {
        window.uni.navigateBack()
        return true
      }
      return false
    },

    /**
     * 返回上一页 / 关闭当前页面
     */
    onClickLeft() {
      // 1. 优先调用原生 closePage 桥接关闭当前 Webview 返回 App 原生页面
      if (this.invokeNativeClosePage()) {
        return
      }
      // 2. 浏览器/H5 历史记录回退兜底
      if (window.history && window.history.length > 1) {
        window.history.back()
      }
    },
    /**
     * 获取金融计算器基准 URL（区分测试与生产环境）
     */
    getCalculatorBaseUrl() {
      // 1. 优先读取环境变量 (例如在 .env.production 或 .env.test 中配置的 VUE_APP_CALCULATOR_URL)
      if (process.env.VUE_APP_CALCULATOR_URL) {
        return process.env.VUE_APP_CALCULATOR_URL
      }

      // 2. 根据域名或 NODE_ENV 自动识别环境
      const { hostname } = window.location
      const isTestEnv = hostname.includes('sy.esvtek.com')
        || hostname === 'localhost'
        || hostname === '127.0.0.1'
        || process.env.NODE_ENV === 'development'

      // 测试环境地址: http://sy.esvtek.com:11212/jac-direct-mall-activity-h5-new/#/financial-calculator
      const testUrl = 'http://sy.esvtek.com:11212/jac-direct-mall-activity-h5-new/#/financial-calculator'
      // 生产环境地址: https://jacwxmp.starnetah.com:9443/jac-direct-mall-activity-h5-new/#/financial-calculator
      const prodUrl = 'https://jacwxmp.starnetah.com:9443/jac-direct-mall-activity-h5-new/#/financial-calculator'

      return isTestEnv ? testUrl : prodUrl
    },

    /* ------------------------------------------------------------------
     * 以下原生定位桥接逻辑暂时停用（改为固定安徽省 / 合肥市），
     * 如需恢复：放开本段注释，并同步恢复 data、created、beforeDestroy、
     * 模板按钮 loading 属性，以及 handleJumpToCalculator 中的调用。
     * ------------------------------------------------------------------
    clearNativeAreaRequest() {
      if (this.nativeAreaTimer) {
        clearTimeout(this.nativeAreaTimer)
        this.nativeAreaTimer = null
      }
      this.nativeAreaResolve = null
      this.nativeAreaReject = null
    },

    invokeNativeProvinceAndCity() {
      if (
        window.HarmonyOS
        && typeof window.HarmonyOS.getProvinceAndCity === 'function'
      ) {
        return window.HarmonyOS.getProvinceAndCity()
      }
      if (window.ohos && typeof window.ohos.getProvinceAndCity === 'function') {
        return window.ohos.getProvinceAndCity()
      }
      if (window.Android && typeof window.Android.getProvinceAndCity === 'function') {
        return window.Android.getProvinceAndCity()
      }
      if (
        window.webkit
        && window.webkit.messageHandlers
        && window.webkit.messageHandlers.getProvinceAndCity
      ) {
        window.webkit.messageHandlers.getProvinceAndCity.postMessage(null)
        return null
      }
      if (window.uni && typeof window.uni.postMessage === 'function') {
        window.uni.postMessage({
          data: {
            action: 'getProvinceAndCity'
          }
        })
        return null
      }
      throw new Error('当前环境不支持获取省市信息')
    },

    rejectNativeAreaRequest(error) {
      const reject = this.nativeAreaReject
      this.clearNativeAreaRequest()
      if (reject) reject(error)
    },

    // 原生回调协议：0 无权限；1 有权限；"provinceId,cityId" 为省市编码。
    handleProvinceAndCityCallback(payload) {
      if (!this.nativeAreaResolve) return

      const value = typeof payload === 'string' ? payload.trim() : payload
      if (value === 0 || value === '0') {
        this.rejectNativeAreaRequest(new Error('请开启定位权限后重试'))
        return
      }

      if (value === 1 || value === '1') {
        // 原生告知已有定位权限，等待原生自动触发第二次带省市编码的回调
        this.nativeAreaPermissionGranted = true
        return
      }

      try {
        let provinceId = ''
        let cityId = ''
        if (typeof value === 'string') {
          // 容错：如果原生传回的是 JSON 字符串
          if (value.startsWith('{')) {
            try {
              const parsed = JSON.parse(value)
              const area = parsed.data || parsed
              provinceId = area.provinceId || ''
              cityId = area.cityId || ''
            } catch (e) {
              // ignore JSON parse error
            }
          }
          if (!provinceId || !cityId) {
            const areaIds = value.split(',').map((item) => item.trim())
            if (areaIds.length >= 2) {
              [provinceId, cityId] = areaIds
            }
          }
        } else if (value && typeof value === 'object') {
          const area = value.data || value
          provinceId = area.provinceId
          cityId = area.cityId
        }

        if (!provinceId || !cityId) {
          throw new Error('原生返回的省市信息不完整')
        }

        const resolve = this.nativeAreaResolve
        this.clearNativeAreaRequest()
        resolve({ provinceId, cityId })
      } catch (err) {
        this.rejectNativeAreaRequest(err)
      }
    },

    requestNativeArea() {
      return new Promise((resolve, reject) => {
        this.nativeAreaResolve = resolve
        this.nativeAreaReject = reject
        this.nativeAreaPermissionGranted = false
        this.nativeAreaTimer = setTimeout(() => {
          this.rejectNativeAreaRequest(new Error('获取省市信息超时，请重试'))
        }, 8000)

        try {
          const result = this.invokeNativeProvinceAndCity()
          if (result !== undefined && result !== null && result !== '') {
            this.handleProvinceAndCityCallback(result)
          }
        } catch (err) {
          const {
            cityId = '',
            provinceId = ''
          } = this.$route.query || {}
          if (cityId && provinceId) {
            this.handleProvinceAndCityCallback(`${provinceId},${cityId}`)
          } else {
            this.rejectNativeAreaRequest(err)
          }
        }
      })
    },
     * ------------------------------------------------------------------ */

    /**
     * 解决 iOS WKWebView 拦截富文本中 a 标签 target="_blank" 或链接无法跳转的问题
     */
    handleRichTextLinkClick(e) {
      if (!e || !e.target) return
      const targetLink = e.target.closest('a')
      if (targetLink) {
        const href = targetLink.getAttribute('href')
        if (href && href !== '#' && !/^javascript:/i.test(href)) {
          e.preventDefault()
          window.location.href = href
        }
      }
    },

    /**
     * 跳转金融计算器 H5 页面（省市编码固定为安徽省 / 合肥市）。
     */
    handleJumpToCalculator() {
      const baseUrl = this.getCalculatorBaseUrl()
      const {
        name = '',
        phone = ''
      } = this.$route.query || {}
      const params = []

      // 辅助函数：判断值是否有效（过滤空值、纯空格及 'null'/'undefined' 字符串）
      const isValidValue = (val) => {
        if (val === undefined || val === null) return false
        const str = String(val).trim()
        return str !== '' && str !== 'null' && str !== 'undefined'
      }

      if (isValidValue(name)) params.push(`name=${encodeURIComponent(String(name).trim())}`)
      if (isValidValue(phone)) params.push(`phone=${encodeURIComponent(String(phone).trim())}`)

      // 不再调用原生定位桥接，固定使用安徽省 / 合肥市的省市编码
      params.push(`provinceId=${encodeURIComponent(DEFAULT_PROVINCE_ID)}`)
      params.push(`cityId=${encodeURIComponent(DEFAULT_CITY_ID)}`)

      // 原生定位取省市的旧逻辑（恢复时放开，并把方法改回 async）
      // try {
      //   const areaInfo = (await this.requestNativeArea()) || {}
      //   const { cityId, provinceId } = areaInfo
      //   if (isValidValue(cityId) && String(cityId) !== '0') {
      //     params.push(`cityId=${encodeURIComponent(String(cityId).trim())}`)
      //   }
      //   if (isValidValue(provinceId) && String(provinceId) !== '0') {
      //     params.push(`provinceId=${encodeURIComponent(String(provinceId).trim())}`)
      //   }
      // } catch (err) {
      //   console.warn('未获取到原生省市信息，继续跳转:', err)
      // } finally {
      //   this.requestingArea = false
      // }

      window.location.href = `${baseUrl}?${params.join('&')}`
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(6px + constant(safe-area-inset-top)) rem(32) 8px;
  padding: calc(6px + env(safe-area-inset-top)) rem(32) 8px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: #ffffff;
  border-bottom: 1px solid #f2f3f5;

  .back {
    width: rem(68);
    font-size: rem(36);
    color: #333333;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .title {
    font-size: rem(32);
    font-weight: 600;
    color: #333333;
    text-align: center;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .placeholder {
    width: rem(68);
  }
}

.finance-zone {
  min-height: 100vh;
  background-color: #ffffff;
  padding-bottom: rem(180);
  box-sizing: border-box;
}

.content-body {
  padding: calc(52px + constant(safe-area-inset-top)) rem(32) rem(32);
  padding: calc(52px + env(safe-area-inset-top)) rem(32) rem(32);
}

.banner-box {
  width: 100%;
  border-radius: rem(24);
  overflow: hidden;
  margin-bottom: rem(40);
  box-shadow: 0 rem(8) rem(24) rgba(216, 0, 15, 0.08);

  .banner-img {
    width: 100%;
    height: auto;
    display: block;
  }

  .banner-default {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 40%, #ffcc80 100%);
    padding: rem(48) rem(40);
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: rem(240);
    position: relative;
    border-radius: rem(24);

    .banner-title {
      font-size: rem(48);
      font-weight: 800;
      color: #6d2c00;
      letter-spacing: rem(2);
      margin-bottom: rem(16);
    }

    .banner-tags {
      display: inline-flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.85);
      border-radius: rem(28);
      padding: rem(8) rem(24);
      font-size: rem(24);
      color: #8c3b00;
      font-weight: bold;

      .tag-dot {
        margin: 0 rem(8);
        color: #ff9800;
      }
    }

    .banner-deco {
      position: absolute;
      right: rem(24);
      bottom: rem(20);
    }
  }
}

.section-box {
  margin-bottom: rem(48);
}

.section-title {
  display: flex;
  align-items: center;
  font-size: rem(34);
  font-weight: bold;
  color: #252628;
  margin-bottom: rem(24);

  .red-line {
    width: rem(8);
    height: rem(32);
    background-color: #CC000C;
    border-radius: rem(4);
    margin-right: rem(16);
  }
}

/* 富文本展示通用样式 */
.rich-text-container {
  font-size: rem(28);
  color: #333333;
  line-height: 1.65;
  word-break: break-all;

  ::v-deep h1, ::v-deep h2, ::v-deep h3 {
    font-size: rem(32);
    font-weight: bold;
    color: #252628;
    margin: rem(16) 0;
  }

  ::v-deep p {
    margin: rem(12) 0;
  }

  ::v-deep img {
    max-width: 100% !important;
    height: auto !important;
    display: block;
    margin: rem(16) auto;
    border-radius: rem(12);
  }

  ::v-deep table {
    width: 100% !important;
    border-collapse: collapse;
    margin: rem(20) 0;

    td, th {
      border: 1px solid #e0e0e0;
      padding: rem(16);
      font-size: rem(26);
    }
  }

  ::v-deep a {
    color: #2f74ff;
    text-decoration: underline;
  }
}

/* 金融产品卡片 */
.product-card {
  position: relative;
  background: linear-gradient(135deg, #FFF2F2 0%, #ffffff 100%);
  border-radius: rem(24);
  padding: rem(32) rem(36);
  margin-bottom: rem(28);

  .card-money-bag {
    position: absolute;
    top: rem(8);
    right: rem(16);
    height: rem(110);
    object-fit: contain;
    pointer-events: none;
  }

  .product-card-title {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: rem(20);
    padding: rem(16);
    background: linear-gradient( 90deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
    border-radius: rem(16);

    .red-square {
      width: rem(16);
      height: rem(16);
      background-color: #CC000C;
      border-radius: rem(4);
      margin-right: rem(12);
      flex-shrink: 0;
    }

    .title-text {
      font-size: rem(28);
      font-weight: 500;
      color: #252628;
    }
  }

  .product-desc {
    font-size: rem(26);
    color: #64656F;
    line-height: 1.6;
  }
}

.loading-box {
  min-height: calc(100vh - rem(180));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .loading-spinner {
    width: rem(64);
    height: rem(64);
    border: rem(6) solid #f2f2f2;
    border-top-color: #CC000C;
    border-radius: 50%;
    animation: loading-rotate 0.8s linear infinite;
  }

  .loading-text {
    margin-top: rem(24);
    font-size: rem(28);
    color: #969799;
  }
}

@keyframes loading-rotate {
  to {
    transform: rotate(360deg);
  }
}

.empty-box {
  padding-top: rem(160);
  padding-bottom: rem(100);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .empty-img {
    width: rem(320);
    height: auto;
    margin-bottom: rem(24);
  }

  .empty-text {
    font-size: rem(28);
    color: #969799;
    text-align: center;
  }
}

.bottom-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: rem(24) rem(40) calc(rem(24) + env(safe-area-inset-bottom));
  background-color: #ffffff;
  box-shadow: 0 rem(-6) rem(24) rgba(0, 0, 0, 0.06);
  z-index: 99;
}

.calc-btn {
  background-color: #CC000C;
  border-color: #CC000C;
  font-size: rem(32);
  font-weight: 400;
  height: rem(92);
  line-height: rem(92);
}
</style>
